import { AbstractControl, ValidationErrors } from '@angular/forms';

export function ibanValidator(
  control: AbstractControl | string,
): ValidationErrors | null {
  const iban =
    typeof control === 'string' || control instanceof String
      ? control.replace(/\s+/g, '').toUpperCase()
      : control.value?.replace(/\s+/g, '').toUpperCase();

  if (!iban || iban.length < 15 || iban.length > 34) {
    return { invalidIban: true };
  }

  const ibanReformatted = iban
    .replace(/\s+/g, '') // Leerzeichen entfernen
    .toUpperCase();

  // Erste 4 Zeichen ans Ende stellen
  const rearranged = ibanReformatted.slice(4) + ibanReformatted.slice(0, 4);

  // Buchstaben durch Zahlen ersetzen: A=10, B=11, ..., Z=35
  const numericIBAN = rearranged
    .split('')
    .map((ch) => (ch.match(/[A-Z]/) ? (ch.charCodeAt(0) - 55).toString() : ch))
    .join('');

  return modulo97(numericIBAN) === 1 ? null : { invalidIban: true };
}

function modulo97(input: string): number {
  // Eingabezeichenfolge in eine reine Zahl umwandeln
  const numericString = input.replace(/[^\d]/g, '');

  // In 9er-Blöcken modulo berechnen, um große Zahlen zu handhaben
  let remainder = '';
  for (let i = 0; i < numericString.length; i += 9) {
    const part = remainder + numericString.substr(i, 9);
    remainder = String(Number(part) % 97);
  }

  return Number(remainder);
}
